export default "__VITE_ASSET__ecf96b0c__"